import { useTranslation } from '../hooks/useTranslation';
import { PAGE_SIZES } from '../utils/format';

function PaginationControls({
  currentPage,
  pageSize,
  totalPages,
  pageInput,
  handlePageChange,
  handlePageSizeChange,
  handlePageInputChange,
  handlePageInputSubmit,
  handlePageInputKeyPress,
  pageSizes = PAGE_SIZES,
}) {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
      <select
        className="form-select form-select-sm"
        style={{ width: 'auto' }}
        value={pageSize}
        onChange={handlePageSizeChange}
      >
        {pageSizes.map((size) => (
          <option key={size} value={size}>
            {size} {t('common.itemsPerPage')}
          </option>
        ))}
      </select>
      <div className="input-group input-group-sm" style={{ width: 'auto' }}>
        <span className="input-group-text">{t('common.goToPage')}</span>
        <input
          type="number"
          className="form-control"
          style={{ width: '70px' }}
          value={pageInput}
          onChange={handlePageInputChange}
          onBlur={handlePageInputSubmit}
          onKeyDown={handlePageInputKeyPress}
          min="1"
          max={totalPages}
        />
        <span className="input-group-text">
          / {totalPages} {t('common.page')}
        </span>
      </div>
      <div className="input-group input-group-sm" style={{ width: 'auto' }}>
        <button
          className="btn btn-outline-primary"
          disabled={currentPage <= 1 || totalPages === 0}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          {t('common.prevPage')}
        </button>
        <span className="input-group-text">{currentPage}</span>
        <button
          className="btn btn-outline-primary"
          disabled={currentPage >= totalPages || totalPages === 0}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          {t('common.nextPage')}
        </button>
      </div>
    </div>
  );
}

export default PaginationControls;
